import React, { Component } from 'react';
import Helmet from "react-helmet";
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import Result from '../../components/toto/result';

// @inject('lineStore')
// @withRouter
export default class ResultPage extends Component { 
	render() {
			return(
				<div className="toto-page">
					<Helmet>
						<title>ИРМ - Предыдущий розигрыш</title>
					</Helmet>
					<div className="toto-page__body">
						<Result />
					</div>
				</div> 
			)
	}
}


// WEBPACK FOOTER //
// ./src/routes/toto/result.jsx